import { useRef, useMemo } from 'react';
import { isEqual } from 'underscore';

function isPrimitive(val) {
  return val == null || /^[sbn]/.test(typeof val);
}

function checkDeps(deps) {
  if (!deps || !deps.length) {
    throw new Error(
      'useDeepCompareEffect should not be used with no dependencies. Use React.useEffect instead.'
    );
  }
  if (deps.every(isPrimitive)) {
    throw new Error(
      'useDeepCompareEffect should not be used with dependencies that are all primitive values. Use React.useEffect instead.'
    );
  }
}

// Inspired by https://github.com/kentcdodds/use-deep-compare-effect/blob/master/src/index.js
function useDeepCompareRef(value) {
  const ref = useRef();

  if (!isEqual(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}

export default function useDeepCompareMemo(callback, deps) {
  if (process.env.NODE_ENV !== 'production') {
    checkDeps(deps);
  }

  return useMemo(callback, useDeepCompareRef(deps));
}



// WEBPACK FOOTER //
// ./app/javascript/app/utils/useDeepCompareMemo.js